import { useSectionsStore } from "@/stores/sections";

export default {
  ALL: () => {
    const sectionsStore = useSectionsStore();
    return sectionsStore.mySectionsMap;
  },

  ARCHIVED_SECTIONS: () => {
    const sectionsStore = useSectionsStore();
    return Object.keys(sectionsStore.myArchivedSectionGroupsMap).length > 0
      ? Object.fromEntries(
          sectionsStore.myArchivedSectionGroupsMap
            .flatMap(g => g.sections)
            .flatMap(t => Object.values(t))
            .map(i => [i.sectionId, i])
        )
      : [];
  },

  GROUP_FOR_ARCHIVED_SECTION: () => sectionId => {
    const sectionsStore = useSectionsStore();
    for (let i = 0; i < sectionsStore.myArchivedSectionGroupsMap.length; i++) {
      if (Object.keys(sectionsStore.myArchivedSectionGroupsMap[i].sections).indexOf(sectionId) > -1) {
        return sectionsStore.myArchivedSectionGroupsMap[i].title;
      }
    }
  },

  SECTION: (state, getters) => sectionId => {
    const sectionsStore = useSectionsStore();
    let section = sectionsStore.mySectionsMap[sectionId];
    if (!section) {
      section = getters.ARCHIVED_SECTIONS[sectionId];
    }
    return section;
  },

  ALL_SECTIONS_DRIVES: state => {
    const sectionsStore = useSectionsStore();
    const driveObjects = [];
    Object.keys(state.sectionRootDriveMap).forEach(key => {
      if (sectionsStore.mySectionsMap[key]) {
        driveObjects.push({
          driveId: state.sectionRootDriveMap[key].id,
          name: sectionsStore.mySectionsMap[key].name,
          additionalData: {
            sectionId: key
          },
          webUrl: state.sectionRootDriveMap[key].webUrl
        });
      }
    });
    return driveObjects;
  },

  SECTION_FROM_DRIVE_ID: (state, getters) => driveId => {
    // Check sectionfolders
    const sectionRootFolder = getters.ALL_SECTIONS_DRIVES.find(asd => asd.driveId === driveId);
    if (sectionRootFolder) {
      return getters.SECTION(sectionRootFolder.additionalData.sectionId);
    }

    // Check subsectionfolders
    const subSectionDriveId = getters.PARENT_OF_SUB_DRIVE(driveId);
    if (subSectionDriveId) {
      const parentDrive = getters.ALL_SECTIONS_DRIVES.find(asd => asd.driveId === subSectionDriveId);

      if (parentDrive) {
        return getters.SECTION(parentDrive.additionalData.sectionId);
      }
    }

    return null;
  },

  ALL_ARCHIVED_SECTIONS_DRIVES: (state, getters) => {
    const driveObjects = [];
    Object.keys(state.sectionRootDriveMap).forEach(key => {
      if (getters.ARCHIVED_SECTIONS[key]) {
        driveObjects.push({
          driveId: getters.ARCHIVED_SECTIONS[key].id,
          name: getters.ARCHIVED_SECTIONS[key].name + " (" + getters.GROUP_FOR_ARCHIVED_SECTION(key) + ")",
          additionalData: {
            sectionId: key
          }
        });
      }
    });
    return driveObjects;
  },

  SECTION_SUB_DRIVES: state => driveId => state.sectionRootSubDrivesMap[driveId],

  PARENT_OF_SUB_DRIVE: state => subDriveId => {
    try {
      for (let i in state.sectionRootSubDrivesMap) {
        if (state.sectionRootSubDrivesMap[i].some(s => s.parentReference.driveId === subDriveId)) {
          return i;
        }
      }
    } catch {
      // eslint-disable-next-line no-empty
    }
    return null;
  },

  ALL_MY_TEACHERS: () => {
    const sectionsStore = useSectionsStore();
    if (!sectionsStore.mySectionsMap) {
      return [];
    }

    return Object.values(sectionsStore.mySectionsMap).flatMap(sec => sec.teachers);
  },

  ALL_MY_STUDENTS: () => {
    const sectionsStore = useSectionsStore();
    if (!sectionsStore.mySectionsMap) {
      return [];
    }

    return Object.values(sectionsStore.mySectionsMap).flatMap(sec => sec.students);
  },

  MEMBER: () => (sectionId, extSysApiUserId) => {
    const sectionsStore = useSectionsStore();
    if (sectionsStore.mySectionsMap[sectionId]) {
      const teachers = sectionsStore.mySectionsMap[sectionId].teachers || [];
      const students = sectionsStore.mySectionsMap[sectionId].students || [];
      const people = teachers.concat(students);
      return people.find(p => p.extSysApiUserId === extSysApiUserId);
    }

    const archivedSection = Object.values(sectionsStore.myArchivedSectionGroupsMap)
      .flatMap(s => s.sections)
      .find(s => (s.sectionId = sectionId));
    if (archivedSection) {
      const teachers = archivedSection[sectionId].teachers || [];
      const students = archivedSection[sectionId].students || [];
      const people = teachers.concat(students);
      return people.find(p => p.extSysApiUserId === extSysApiUserId);
    }
    return null;
  },

  MEMBERS: state => sectionId => {
    const teachers = state.sectionsTeachersMap[sectionId] || [];
    const students = state.sectionsStudentsMap[sectionId] || [];
    return teachers.concat(students);
  },

  TEACHERS: state => sectionId => state.sectionsTeachersMap[sectionId] || [],
  STUDENTS: state => sectionId => state.sectionsStudentsMap[sectionId] || []
};
